import { toast, ToastOptions } from "react-toastify";

// Inject CSS into <head> to override default icon color
const injectToastStyles = () => {
  const styleId = "custom-toast-icon-style";
  if (!document.getElementById(styleId)) {
    const style = document.createElement("style");
    style.id = styleId;
    style.innerHTML = `
      /* ✅ White icon for all toasts */
      .Toastify__toast-icon svg {
        fill: #fff !important;
        color: #fff !important;
      }

      /* ✅ Ensure warning icon is also white */
      .Toastify__toast--warning .Toastify__toast-icon svg {
        fill: #fff !important;
        color: #fff !important;
      }
    `;
    document.head.appendChild(style);
  }
};

// Inject once
injectToastStyles();

const baseOptions: ToastOptions = {
  position: "top-center",
  autoClose: 3000,
  closeButton: false,
  hideProgressBar: false,
  pauseOnHover: true,
  draggable: false,
};

export const showToast = {
  success: (message: string) =>
    toast.success(message, {
      ...baseOptions,
      style: {
        backgroundColor: "#28a745",
        color: "#fff",
      },
    }),

  error: (message: string) =>
    toast.error(message, {
      ...baseOptions,
      style: {
        backgroundColor: "#ed682f",
        color: "#fff",
      },
    }),

  warning: (message: string) =>
    toast.warning(message, {
      ...baseOptions,
      style: {
        backgroundColor: "#ffc107", // Yellow
        color: "#fff",              // White text
      },
    }),

  info: (message: string) =>
    toast.info(message, {
      ...baseOptions,
      style: {
        backgroundColor: "#17a2b8",
        color: "#fff",
      },
    }),
};
